import apiFetch from '../../apiFetch'

export default function (dossierId, token) {
  return apiFetch({
    endPoint: `dossier/paperworkHistorical/${dossierId}`,
    method: 'GET',
    body: null,
    token: token
  })
}
